import { OnlyNumbersMask } from 'react-masked-text/src/masks/only-numbers.mask';

const onlyNumbers = value => {
  const only = new OnlyNumbersMask();
  return only.getRawValue(value.trim());
};

export { onlyNumbers };
